import styled, { css } from 'styled-components'
import { Terms } from '../Footer/styles'

export const Container = styled.div``

export const TabMenu = styled.div`
  width: 300px;
  display: flex;
  margin-right: auto;
  gap: 10px;

  z-index: 0;

  @media(max-width: 767px) {
    width: 100%;
  }

  @media(max-width: 424px) {
    width: 100%;
  }
`

export const TabButton = styled.button`
  display: flex;
  width: 100%;
  min-height: 8px;
  flex-direction: column;
  align-items: center;
  padding: 6px 7px 20px;

  border: none;
  border-radius: 5px 5px 0px 0px;
  color: #7C85A8;
  font-family: "Platform Web";
  font-size: 16px;
  background: #EAECEC;

  ${({ isActive }) => isActive && css`
    background: #0E1E64;
    color: #fff;
  `}
`

export const FirstCardWrapper = styled.div`
  max-width: 288px;
  width: 100%;
`

export const CardsContainer = styled.div`
  position: relative;
  top: -15px;
  z-index: 1;
`

export const DesktopCards = styled.div`
  display: flex;
  gap: 10px;

  @media(max-width: 767px) {
    display: none;
  }
`

export const SmallText = styled(Terms)`
  margin-top: 12px;
  justify-content: flex-start;
  font-size: 14px;
  font-weight: 500;
  font-family: "Platform Web";

  @media(max-width: 767px) {
    padding: 0;
  }

  p {
    color: #7B7B7A;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    margin: 0;

    @media(max-width: 767px) {
      line-height: 20px;
    }
  }
`;

export const MobileCards = styled.div`
  position: relative;

  @media(min-width: 767px) {
    display: none;
  }
`

export const NavigateButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background: transparent;
  transition: all 0.1s;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.5;
  }

  img {
    background-repeat: no-repeat;
  }

`

export const NavigateLeft = styled(NavigateButton)`
  left: -15px;
`

export const NavigateRight = styled(NavigateButton)`
  right: -15px;

  @media(max-width: 424px) {
    right: -15px;
  }
`